module.exports = __webpack_public_path__ + "static/media/backsplash3_lowres.649f0a08.jpg";